import * as t from "io-ts";
export const stringLiteral = (options, name) => new t.Type(name, (u) => typeof u === "string" && options.includes(u), (i, ctx) => {
    if (typeof i !== "string") {
        return t.failure(i, ctx, "Wrong type: " + typeof i);
    }
    if (options.includes(i)) {
        return t.success(i);
    }
    return t.failure(i, ctx, "Invalid value: " + i);
}, (v) => v);
export const numberLiteral = (options, name) => new t.Type(name, (u) => typeof u === "number" && options.includes(u), (i, ctx) => {
    if (typeof i !== "number") {
        return t.failure(i, ctx, "Wrong type: " + typeof i);
    }
    if (options.includes(i)) {
        return t.success(i);
    }
    return t.failure(i, ctx, "Invalid value: " + i);
}, (v) => v);
//# sourceMappingURL=const-array.js.map